export default class Scroll {
    static callsToUnlock = 0

    static lock() {
        if(this.callsToUnlock === 0) document.body.style.overflow = 'hidden'

        this.callsToUnlock++
    }

    static unlock(force = false) {
        this.callsToUnlock = force ? 0 : Math.max(0, this.callsToUnlock - 1)
    
        if(this.callsToUnlock === 0) document.body.style.overflow = ''
    }
}